import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { pickDataAttributes } from '../../utils/pickDataAttributes';
import { TextRoot } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Text` with a curated props API covering the `as` element, `variant`, and
 * truncation props plus a focused accessibility attribute set, without the full
 * HTMLElement attribute surface.
 *
 * @see {@link TextRoot | Text}
 */
export const Text = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = _c(16);
  const {
    children,
    as,
    variant,
    truncated,
    lineClamp,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    ariaDescription,
    dataTestId,
    dataAttributes
  } = t0;
  const t1 = id === null || id === void 0 ? void 0 : id.root;
  const t2 = ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root;
  const t3 = ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root;
  const t4 = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root;
  const t5 = ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root;
  let t6;
  if ($[0] !== dataAttributes) {
    t6 = pickDataAttributes(dataAttributes);
    $[0] = dataAttributes;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root;
  let t8;
  if ($[2] !== as || $[3] !== children || $[4] !== lineClamp || $[5] !== ref || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== truncated || $[14] !== variant) {
    t8 = /*#__PURE__*/_jsx(TextRoot, Object.assign({
      ref: ref,
      as: as,
      variant: variant,
      truncated: truncated,
      lineClamp: lineClamp,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5
    }, t6, {
      "data-test-id": t7,
      children: children
    }));
    $[2] = as;
    $[3] = children;
    $[4] = lineClamp;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = truncated;
    $[14] = variant;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
});
Text.displayName = 'Text';